import React from "react";
import CountUp from "react-countup";
import { Container, Grid, Box, Typography } from "@mui/material";

// MUI Icons
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import GroupsIcon from "@mui/icons-material/Groups";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import LocationCityIcon from "@mui/icons-material/LocationCity";

const FunFact = (props) => {
  const { theme = "light" } = props;

  const funFacts = [
    {
      title: 150,
      subTitle: "Cumulative Years of Experience",
      Symbol: "+",
      Icon: <WorkspacePremiumIcon sx={{ fontSize: 45 }} />,
    },
    {
      title: 500,
      subTitle: "Corporate Clients",
      Symbol: "+",
      Icon: <GroupsIcon sx={{ fontSize: 45 }} />,
    },
    {
      title: 100,
      subTitle: "Team Strength",
      Symbol: "+",
      Icon: <PeopleAltIcon sx={{ fontSize: 45 }} />,
    },
    {
      title: 500,
      subTitle: "Assignments Delivered",
      Symbol: "+",
      Icon: <AssignmentTurnedInIcon sx={{ fontSize: 45 }} />,
    },
    {
      title: 5,
      subTitle: "Strategic Offices",
      Symbol: "+",
      Icon: <LocationCityIcon sx={{ fontSize: 45 }} />,
    },
  ];

  const themeColors = {
    primary: "var(--primary-color)",
    secondary: "var(--secondary-color)",
    white: "#fff",
    accent:
      theme === "dark"
        ? "rgba(255, 255, 255, 0.15)"
        : "rgba(26, 66, 161, 0.05)",
    bg: theme === "dark" ? "var(--primary-color)" : "#fff",
    text: theme === "dark" ? "#fff" : "var(--primary-color)",
    subText: theme === "dark" ? "rgba(255, 255, 255, 0.8)" : "#555",
  };

  return (
    <Box
      component="section"
      className={`fun-fact-section ${props.fClass}`}
      sx={{
        backgroundColor: themeColors.bg,
        py: { xs: 4, md: 6 },
        position: "relative",
        overflow: "hidden",
        "&::before":
          theme === "dark"
            ? {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundImage:
                  "linear-gradient(45deg, rgba(255,255,255,0.03) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.03) 50%, rgba(255,255,255,0.03) 75%, transparent 75%, transparent)",
                backgroundSize: "60px 60px",
                opacity: 0.1,
              }
            : {},
      }}
    >
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Box sx={{ textAlign: "center", mb: { xs: 4, md: 5 } }}>
          <Typography
            variant="h2"
            sx={{
              color: themeColors.text,
              fontWeight: 800,
              fontSize: { xs: "2rem", md: "2.75rem" },
              textTransform: "uppercase",
              letterSpacing: "2px",
              mb: 2,
              fontFamily: "'Roboto Slab', serif",
            }}
          >
            Speaking Numbers
          </Typography>
          <Box
            sx={{
              width: "80px",
              height: "4px",
              backgroundColor: themeColors.text,
              margin: "0 auto",
              borderRadius: "2px",
            }}
          />
        </Box>

        <Grid container spacing={4} justifyContent="center">
          {funFacts.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} lg={2.4} key={index}>
              <Box
                sx={{
                  textAlign: "center",
                  p: 3,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.4s ease",
                  borderRadius: "24px",
                  background: theme === "dark" ? themeColors.accent : "#fff",
                  backdropFilter: theme === "dark" ? "blur(5px)" : "none",
                  border:
                    theme === "dark"
                      ? "1px solid rgba(255, 255, 255, 0.1)"
                      : "1px solid rgba(26, 66, 161, 0.1)",
                  boxShadow:
                    theme === "dark" ? "none" : "0 10px 30px rgba(0,0,0,0.05)",
                  "&:hover": {
                    transform: "translateY(-10px)",
                    borderColor: themeColors.text,
                    background:
                      theme === "dark" ? "rgba(255, 255, 255, 0.25)" : "#fff",
                    boxShadow:
                      theme === "dark"
                        ? "0 15px 35px rgba(0,0,0,0.2)"
                        : "0 15px 35px rgba(26, 66, 161, 0.1)",
                  },
                }}
              >
                <Box
                  sx={{
                    color: themeColors.text,
                    mb: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    opacity: 0.9,
                  }}
                >
                  {item.Icon}
                </Box>

                <Typography
                  variant="h3"
                  sx={{
                    color: themeColors.text,
                    fontWeight: 700,
                    fontSize: { xs: "2.5rem", md: "2.75rem" },
                    mb: 1,
                    display: "flex",
                    alignItems: "baseline",
                    justifyContent: "center",
                  }}
                >
                  <CountUp end={item.title} enableScrollSpy duration={2.5} />
                  <Typography
                    component="span"
                    sx={{
                      fontSize: "1.5rem",
                      fontWeight: 700,
                      ml: 0.5,
                      color: themeColors.text,
                      opacity: 0.6,
                    }}
                  >
                    {item.Symbol}
                  </Typography>
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    color: themeColors.subText,
                    fontSize: "0.9rem",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    letterSpacing: "1px",
                    lineHeight: 1.4,
                  }}
                >
                  {item.subTitle}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default FunFact;
